import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, getTestId, Input, isValidObject, Typography } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { getSimOwnerDetailsStyles } from './SimOwnerDetailsStyles';
export var SimOwnerDetails = _ref => {
  var id = _ref.id,
    index = _ref.index,
    title = _ref.title,
    inputsDataProps = _ref.inputsDataProps,
    dropdownProps = _ref.dropdownProps,
    theme = _ref.theme,
    onChange = _ref.onChange,
    testID = _ref.testID,
    onUserAction = _ref.onUserAction;
  var _ref2 = inputsDataProps || {},
    ownerName = _ref2.ownerName,
    mobileNumber = _ref2.mobileNumber;
  var _ref3 = dropdownProps || {},
    relationship = _ref3.relationship,
    simProvider = _ref3.simProvider;
  var _useState = useState(ownerName),
    ownerNameState = _useState[0],
    setOwnerNameState = _useState[1];
  var _useState2 = useState(mobileNumber),
    mobileNumberState = _useState2[0],
    setMobileNumberState = _useState2[1];
  var _useState3 = useState(relationship),
    relationshipState = _useState3[0],
    setRelationshipState = _useState3[1];
  var _useState4 = useState(simProvider),
    simProviderState = _useState4[0],
    setSimProvider = _useState4[1];
  useEffect(() => {
    setOwnerNameState(prev => Object.assign(Object.assign({}, prev), ownerName));
  }, [JSON.stringify(ownerName)]);
  useEffect(() => {
    setMobileNumberState(prev => Object.assign(Object.assign({}, prev), mobileNumber));
  }, [JSON.stringify(mobileNumber)]);
  useEffect(() => {
    setRelationshipState(prev => Object.assign(Object.assign({}, prev), relationship));
  }, [JSON.stringify(relationship)]);
  useEffect(() => {
    setSimProvider(prev => Object.assign(Object.assign({}, prev), simProvider));
  }, [JSON.stringify(simProvider)]);
  var simOwnerDetailsStyles = getSimOwnerDetailsStyles();
  var zIndex = 9999 - index;
  var onChangeHandler = (id, key, value) => {
    var onChangeMetaData = {};
    switch (key) {
      case 'ownerName':
        onChangeMetaData = ownerNameState.onChangeMetaData;
        break;
      case 'mobileNumber':
        onChangeMetaData = mobileNumberState.onChangeMetaData;
        break;
      case 'relationship':
        onChangeMetaData = relationshipState.onChangeMetaData;
        break;
      case 'simProvider':
        onChangeMetaData = simProviderState.onChangeMetaData;
        break;
    }
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeMetaData), {
      value: value
    }));
    onChange(id, key, value);
  };
  var onClearSimProvider = id => {
    onChangeHandler(id, 'simProvider', '');
  };
  var onClearRelationShip = id => {
    onChangeHandler(id, 'relationship', '');
  };
  return _jsxs(View, Object.assign({
    style: [simOwnerDetailsStyles.content, {
      zIndex
    }]
  }, getTestId(testID, "sim_owner_details_" + index), {
    children: [_jsx(Typography, Object.assign({
      style: simOwnerDetailsStyles.title,
      text: title,
      type: "body-para-md-bold"
    }, getTestId(testID, "title_" + index))), _jsx(Input, Object.assign({}, ownerNameState, {
      theme: theme,
      style: [simOwnerDetailsStyles.input, ownerNameState.style],
      onChangeText: text => onChangeHandler(id, 'ownerName', text)
    }, getTestId(testID, "owner_input_" + index))), _jsx(Input, Object.assign({}, mobileNumberState, {
      theme: theme,
      style: [simOwnerDetailsStyles.input, mobileNumberState.style],
      onChangeText: text => onChangeHandler(id, 'mobileNumber', text)
    }, getTestId(testID, "mobile_number_" + index))), _jsx(Dropdown, Object.assign({}, relationshipState, {
      theme: theme,
      style: [simOwnerDetailsStyles.input, relationshipState.style, {
        zIndex
      }],
      onSelectedHandler: data => {
        var _a;
        return onChangeHandler(id, 'relationship', (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.value);
      },
      clearInputOnBlur: true,
      onInputClear: () => onClearRelationShip(id),
      position: "below",
      listMaxHeightPercentage: 30
    }, getTestId(testID, "relationship_" + index))), _jsx(Dropdown, Object.assign({}, simProviderState, {
      theme: theme,
      style: [simOwnerDetailsStyles.input, simProviderState.style, {
        zIndex: zIndex - 100
      }],
      onSelectedHandler: data => {
        var _a;
        return onChangeHandler(id, 'simProvider', (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.value);
      },
      clearInputOnBlur: true,
      onInputClear: () => onClearSimProvider(id),
      position: "below",
      listMaxHeightPercentage: 30
    }, getTestId(testID, "sim_provider_" + index)))]
  }));
};